import { useLocation } from 'react-router-dom';

import { Link } from '@/marketing/link';
import shiftLogo from '@/assets/shift-logo-ink.png';
import { AI_BOOST_DEMO_FORM_URL, SHIFT_AI_URL } from '@/lib/links';

export function Navbar() {
  const { pathname: location } = useLocation();

  const navLinks = [
    { href: '/engine', label: 'The Engine' },
    { href: '/ceos', label: 'For leaders' },
    { href: '/pricing', label: 'Plans' },
    { href: '/faq', label: 'FAQ' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/90 backdrop-blur-md border-b border-border">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link href="/" className="flex items-center gap-3 group">
          <img src={shiftLogo} alt="SHIFT" className="h-9 w-auto" />
          <span className="w-px h-6 bg-foreground/20"></span>
          <span className="font-sans font-bold text-2xl tracking-tighter text-foreground group-hover:text-primary transition-colors">AI Boost</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8 text-xs font-semibold uppercase tracking-wider font-mono">
          <a
            href={SHIFT_AI_URL}
            className="text-foreground/60 hover:text-primary transition-colors"
          >
            ← SHIFT AI
          </a>
          {navLinks.map((link) => (
            <Link 
              key={link.href} 
              href={link.href}
              className={`hover:text-primary transition-colors ${location === link.href ? 'text-primary' : 'text-foreground'}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-4">
          <Link
            href="/login"
            className="inline-flex items-center border border-foreground px-4 py-2.5 text-[10px] font-bold uppercase tracking-widest text-foreground transition-colors hover:border-primary hover:bg-primary hover:text-primary-foreground md:text-xs"
          >
            Log in
          </Link>
          <a 
            data-testid="link-navbar-demo"
            href={AI_BOOST_DEMO_FORM_URL}
            target="_blank"
            rel="noreferrer"
            className="hidden items-center gap-2 bg-primary text-primary-foreground px-5 py-2.5 text-[10px] md:text-xs font-mono uppercase tracking-widest hover:bg-foreground transition-colors font-bold sm:flex"
          >
            Request a demo
          </a>
        </div>
      </div>
    </header>
  );
}
